export const SEARCH_STATE_KEY = 'lastSearchState';
export const SEARCH_LOB_KEY = 'lastSearchLob';
export const SEARCH_TYPE_KEY = 'lastSearchType';